module.exports = __webpack_public_path__ + "assets/img/life-6.a59b5175.jpg";